import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ISDialogComponent } from './is-dialog.component';
import { InsertionDirective } from './insertion.directive';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatSliderModule } from '@angular/material/slider';
import { CdkMenuModule } from '@angular/cdk/menu';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { ResizeDirective } from './resize.directive';
import { ContenteditableDirective } from './content-editable.directive';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { DialogRef } from './is-dialog-ref';
import { A11yModule } from '@angular/cdk/a11y';
import { NgxSpinnerModule } from 'ngx-spinner';

const materialModules = [
    MatIconModule,
    MatTooltipModule,
    MatDialogModule,
    MatMenuModule,
    MatSliderModule,
    MatTooltipModule,
    DragDropModule,
    FormsModule
];

@NgModule({
    declarations: [ISDialogComponent, InsertionDirective, ResizeDirective, ContenteditableDirective],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        CdkMenuModule,
        CdkAccordionModule,
        ClipboardModule,
        A11yModule,
        NgxSpinnerModule,
        ...materialModules
    ],
    exports: [ISDialogComponent],
    providers: [ {
        provide: DialogRef,
        useValue: {}
      }],
})
export class ISDialogModule {}